export class WebLightmap {
    destroy() {
        this.lightmapColor = null;
        this.lightmapDirection = null;
    }
}
